var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"label":"Text"}},[_c('b-input',{model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1),_c('b-form-group',{attrs:{"label":"Subtext"}},[_c('b-input',{model:{value:(_vm.subtext),callback:function ($$v) {_vm.subtext=$$v},expression:"subtext"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }